import { forwardFromYaw } from '@etown/shared';

/**
 * Wie weit ein Peer aus der Mitte gepannt wird. Volle Aussteuerung nach links
 * oder rechts klingt unnatuerlich, weil ein Ohr dann gar nichts mehr hoert.
 */
const MAX_PAN = 0.85;
/**
 * Innerhalb dieser Entfernung wird kaum gepannt — wer direkt neben einem
 * steht, soll nicht bei jedem Schritt von links nach rechts springen.
 */
const NEUTRAL_RADIUS_TILES = 0.6;

/**
 * Stereo-Position eines Peers: -1 ganz links, 0 mittig, +1 ganz rechts.
 *
 * Bezugsrichtung ist der Blick. In der Ego-Ansicht ist das der `yaw`, in der
 * Draufsicht blickt man von oben nach Norden — dort entspricht das Panning
 * damit der Position links oder rechts auf dem Bildschirm.
 */
export function panForPeer(
  selfX: number,
  selfY: number,
  peerX: number,
  peerY: number,
  yaw: number | null,
): number {
  const dx = peerX - selfX;
  const dy = peerY - selfY;
  const distance = Math.hypot(dx, dy);
  if (distance < NEUTRAL_RADIUS_TILES) return 0;

  const forward = forwardFromYaw(yaw ?? 0);
  // Rechts steht senkrecht auf der Blickrichtung
  const right = { x: -forward.y, y: forward.x };
  const sideways = (dx * right.x + dy * right.y) / distance;
  return clamp(sideways, -1, 1) * MAX_PAN;
}

function clamp(value: number, min: number, max: number): number {
  return value < min ? min : value > max ? max : value;
}
